<template>
  <el-form
    label-width="100px"
    :model="form"
    :disabled="disabled"
  >
    <el-row>
      <el-col :span="10">
        <el-form-item label="歌曲审核状态">
          <el-radio-group v-model="form.album_status_list" @change="search">
            <el-radio-button
              v-for="(item,i) in checkConditionOption"
              :key="i"
              :label="item[0]"
            >
              {{ item[1] }}
            </el-radio-button>
          </el-radio-group>
        </el-form-item>
      </el-col>

      <el-col :span="14">
        <el-form-item label="歌曲付费口径">
          <el-checkbox-group v-model="form.payment_mode" @change="search">
            <el-checkbox-button
              v-for="(item,key) in checkPaymentMap"
              :key="key"
              :label="key"
            >
              {{ item }}
            </el-checkbox-button>
          </el-checkbox-group>
        </el-form-item>
      </el-col>

      <el-col :span="24">
        <el-form-item>
          <p class="collapse-tip" @click="showCollapse = !showCollapse">
            {{ collapseTip }}
            <i class="el-icon-arrow-down" :class="showCollapse ? 'transfrom' : ''" />
          </p>
        </el-form-item>
      </el-col>
    </el-row>

    <div class="hide-form" :style="{ height: showCollapse ? 'auto' : '0' }">
      <el-row :gutter="15">
        <el-col :span="24">
          <el-form-item label="歌曲申请ID">
            <multiple-input
              type="textarea"
              :rows="2"
              v-model="form.trackIdList"
              :placeholder="$t('track.trackIdPlaceholder')"
              formatter="number"
              clearable
            ></multiple-input>
          </el-form-item>
        </el-col>

        <el-col :span="8">
          <el-form-item label="歌手名">
            <el-input
              @keyup.enter.native="search"
              placeholder="精确查询"
              v-model="form.singer_name"
              clearable
            ></el-input>
          </el-form-item>
        </el-col>

        <el-col :span="8">
          <el-form-item label="歌曲ISRC">
            <el-input
              @keyup.enter.native="search"
              :placeholder="$t('track.isrcPlaceholder')"
              v-model="form.isrc"
              clearable
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="录音合同编号">
            <el-input
              @keyup.enter.native="search"
              v-model="form.contract"
              :placeholder="$t('common.contractPlaceholder')"
              clearable
            ></el-input>
          </el-form-item>
        </el-col>

        <el-col :span="8">
          <el-form-item :label="$t('track.exclusivity')">
            <el-select
              class="form-select-field"
              @change="search"
              :placeholder="$t('track.exclusivityPlaceholder')"
              v-model="form.is_only"
              clearable
            >
              <el-option
                v-for="(item, key) in isOnlyMap"
                :key="key"
                :value="+key"
                :label="$t(`const.isOnlyMap[${key}]`)"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>

        <el-col :span="8">
          <el-form-item :label="$t('track.licensorRole')">
            <el-select
              class="form-select-field"
              @change="search"
              :placeholder="$t('track.licensorRolePlaceholder')"
              v-model="form.is_agent"
              clearable
            >
              <el-option
                v-for="(item, key) in isAgentMap"
                :key="+key"
                :value="+key"
                :label="$t(`const.isAgentMap[${key}]`)"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>

        <el-col :span="8">
          <el-form-item :label="$t('track.wmExclusivity')">
            <el-select
              class="form-select-field"
              @change="search"
              :placeholder="$t('track.wmExclusivityPlaceholder')"
              v-model="form.can_legal_rights"
              clearable
            >
              <el-option
                v-for="(item, key) in canLegalRightsMap"
                :key="key"
                :value="+key"
                :label="$t(`const.canLegalRightsMap[${key}]`)"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
    </div>
  </el-form>
</template>

<script>
import {
  languageMap,
  checkConditionOption,
  isOnlyMap,
  isAgentMap,
  canLegalRightsMap,
  hiddenReasonMap
} from '@/utils/constants'
import { checkPaymentMap } from '../../../album/mixin'
import { cloneDeep, isUndefined } from 'lodash-es'
import MultipleInput from '@/components/MultipleInput/index'

export default {
  name: 'CheckingSearchForm',
  components: {
    MultipleInput
  },
  props: {
    disabled: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      languageMap,
      checkPaymentMap,
      canLegalRightsMap,
      isOnlyMap,
      checkConditionOption,
      isAgentMap,
      type: 1,
      hiddenReasonMap,
      showCollapse: false,
      form: {}
    }
  },

  computed: {
    formatForm() {
      const form = cloneDeep(this.form)
      if (this.type === 2) {
        form.track_name__icontains = form.track_name
        form.track_name = ''
      }

      form.payment_mode = form.payment_mode.join(',')
      return form
    },
    collapseTip() {
      return this.showCollapse ? '收起全部' : '更多筛选条件'
    }
  },

  created() {
    this.handleReset()
  },

  methods: {
    initData(data) {
      const { isAgent, isOnly, isFree, canLegalRights, contract } = data

      if (!isUndefined(isAgent)) {
        this.form.is_agent = +isAgent
      }

      if (!isUndefined(isOnly)) {
        this.form.is_only = +isOnly
      }

      if (!isUndefined(canLegalRights)) {
        this.form.can_legal_rights = +canLegalRights
      }

      if (!isUndefined(isFree)) {
        const [free, ...payment] = Object.keys(checkPaymentMap).map(val => +val)
        this.form.payment_mode = isFree
          ? [free]
          : payment
      }

      if (!isUndefined(contract)) {
        this.form.contract = contract
      }
    },
    handleReset() {
      this.form = {
        album_status_list: [3, 4],
        payment_mode: [],
        trackIdList: '',
        singer_name: '',
        isrc: '',
        contract: '',
        is_only: '',
        is_agent: '',
        can_legal_rights: '',
      }
    },
    search() {
      this.$emit('search')
    }
  },
}
</script>

<style lang="scss" scoped>
.form-select-field {
  width: 100%;
}
.collapse-tip {
  margin-top: 1px;
  margin-right: 5px;
  float: right;
  color: #4071ff;
  cursor: pointer;
  font-size: 12px;

  i {
    transition: all 0.3s linear;
    &.transfrom {
      transform: rotate(180deg);
    }
  }
}

.hide-form {
  overflow: hidden;
  transition: all .3s linear;
}

.input-with-select {
  width: 100px;
}

::v-deep {
   .el-form-item--mini.el-form-item{
       margin-bottom: 14px;
    }
}
</style>
